import { camelize } from '@src/packages/utils';

const EMPTY_COUNTER_DATA = {
  percentageTotal: 0,
  completed: 0,
  notCompleted: 0,
  expected: 0,
  finished: 0,
};

export const transformCounterData = result => {
  const { data: agg } = camelize(result);
  if (!agg) {
    return EMPTY_COUNTER_DATA;
  }

  const data = agg?.aggregations?.totals?.buckets?.all || {};
  const { totalCompletionPercentage, completed, notCompleted, triggersNested } = data;

  const expected = triggersNested?.totalExpected?.value ?? 0;
  const finished = triggersNested?.totalFinished?.value ?? 0;

  return {
    percentageTotal: totalCompletionPercentage?.value ?? 0,
    completed: completed?.value ?? 0,
    notCompleted: notCompleted?.value ?? 0,
    expected,
    finished,
  };
};
